// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1HIfv","errors":"Errors_errors__1taxe"};